
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/janrain-pages/ChildRejection",
      function () {
        return require("private-next-pages/janrain-pages/ChildRejection.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/janrain-pages/ChildRejection"])
      });
    }
  